import Choices from 'choices.js'

const debug = false;

const hubSpotNewsletterForm = () => {

  debug ? console.log('hubspot') : '';

  const form = document.querySelector('.hbspt-form form')
  const submitBtn = form.querySelector('input[type="submit"]')
  const checkBox = form.querySelector('.hs-form-booleancheckbox input')
  let selectMenu = form.getElementsByTagName('select');

  checkBox.classList.add('form-check-input');
  submitBtn.classList.add('btn', '-solid');


  //  get the form field labels and add to <inputs> as placeholders (design requirement)
  const formFields = [...document.querySelectorAll('.hs-form-field')];

  formFields.forEach(formField => {
    const label = formField.getElementsByTagName('label')[0];
    const labelText = label.innerText;
    const formInput = formField.getElementsByClassName('hs-input')[0];
    formInput.setAttribute('placeholder', labelText);
    // visually hide the labels
    let checkbox = label.classList.contains('hs-form-booleancheckbox-display');

    if(false == checkbox){
      label.classList.add('sr-only')
    }
  });

  // style the <select> menu
  if(selectMenu) {
    selectMenu = selectMenu[0]
    new Choices(selectMenu, {
      shouldSort: false,
      placeholder: true,
      placeholderValue: 'Country',
      searchPlaceholderValue: 'Country',
      itemSelectText: '',
    })
  }

  // move the submit btn inline with <select> (design requirement)
  const countrySelect = form.querySelector('fieldset:nth-child(3)');
  const submitField = form.querySelector('.hs-submit')

  if(countrySelect){
    let mql = window.matchMedia('(min-width: 501px)');
    if(mql.matches) {
      countrySelect.insertAdjacentElement('afterend', submitField)
    }
    window.addEventListener('resize',  () => {
      let mql = window.matchMedia('(min-width: 501px)');
      if(mql.matches) {
        countrySelect.insertAdjacentElement('afterend', submitField)
      }
    })
  }

  // update privacy policy link with current locale
  const localisePrivacylink = () => {
    const outerHTML = document.getElementsByTagName('html')[0]
    let locale = outerHTML.getAttribute('data-localeroot')
    const privacyLink = document.querySelector('.hs-form-booleancheckbox a')
    const privacyLinkGeneral = privacyLink.getAttribute('href')
    if(locale == '/') {
      return
    }
    const privacyLinkLocalised = privacyLinkGeneral.replace('.com/', `.com${locale}`);
    privacyLink.setAttribute('href', privacyLinkLocalised)
  }
  localisePrivacylink()

}

// When form is rendered and modified by hubSpot, we can then modify it
window.addEventListener('message', function(e) {
  if(e.data.type === 'hsFormCallback' && e.data.eventName === 'onFormReady') {
    debug ? console.log('hubspot form ready') : '';
    hubSpotNewsletterForm();
  }
});
